module.exports = __webpack_public_path__ + "static/media/screenshot3.d8888bb1.jpg";